import { useExportPeople } from "@/mutations/useExportPeople.tsx";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { Button, CircularProgress } from "@mui/material";

const ExportPeople = () => {
    const exportPeople = useExportPeople();

    const handleExportData = () => {
        exportPeople.mutate();
    };

    return (
        <Button
            onClick={handleExportData}
            startIcon={
                exportPeople.isPending ? <CircularProgress size={16} /> : <FileDownloadIcon />
            }
            variant="contained"
            size="small"
            disabled={exportPeople.isPending}
        >
            {exportPeople.isPending ? "Exporting..." : "Export"}
        </Button>
    );
};

export default ExportPeople;
